var form = require("./Form.jsx");

var React = require("react");
var ReactDOM = require("react-dom");
const createReactClass = require('create-react-class');

var EditStackForm = createReactClass({

	getInitialState: function() {
		return {
			show: this.props.model.initialShow,
			securityID: this.props.model.InitialSecurityID,
			isSubmitting: false
		};
	},

	componentDidMount: function() {
		this.modal({show: this.state.show});
	},

	componentDidUpdate: function() {
		this.modal({show: this.state.show});
	},

	onSuccess: function() {
		location.reload();
	},

	modal: function(options) {
		$(ReactDOM.findDOMNode(this)).modal(options);
	},

	render: function() {
		return (
			<div className="modal fade">
				<div className="modal-dialog">
					<div className="modal-content">
						<div className="modal-header">
							<button type="button" className="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
							<h4 className="modal-title">Edit stack</h4>
						</div>
						<div className="modal-body">
							<form.Form
								ref="editstackform"
								url={this.props.model.action}
								securityID={this.state.securityID}
								initialIsSubmitting={this.state.isSubmitting}
								afterSuccess={this.onSuccess}
								buttonTitle="Save changes"
								buttonSubmittingTitle="Saving changes..."
							>

								<div className="form-group">
									<label htmlFor="name">Stack title</label>
									<form.Input id="name" name="Name" value={this.props.model.projectName} placeholder={this.props.model.projectCode} />
								</div>
								<div className="form-group">
									<label htmlFor="description">Stack description</label>
									<form.Textarea id="description" name="Description" rows="4" value={this.props.model.projectDescription} />
								</div>
								<div className="form-group">
									<label>Git repository URL</label>
									<div>{this.props.model.CVSPath}</div>
									<div className="help-text">Please contact our support team to change the Git URL.</div>
								</div>
							</form.Form>
						</div>
					</div>
				</div>
			</div>
		);
	}
});

module.exports = EditStackForm;
